export function formatMoney(val: number, customCurrency?: string, skipCents?: boolean): string {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: customCurrency ?? window.$app.appConfig.currency,
    maximumFractionDigits: skipCents ? 0 : 2,
  }).format(val / 100);
}
